export type BlackDiamondWPInboundContactSyncSettings = {
  autoSync: boolean
}

export type BlackDiamondWPInboundSyncSettings = {
  contact: BlackDiamondWPInboundContactSyncSettings
}

export type BlackDiamondWPSettingsFormValues = {
  inbound: BlackDiamondWPInboundSyncSettings
}

export const blackDiamondWPSettingsDefaultValues: BlackDiamondWPSettingsFormValues = {
  inbound: {
    contact: {
      autoSync: false,
    },
  },
}
